/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Chart from 'react-apexcharts';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader, Button,
  Nav, NavItem, NavLink, TabContent, TabPane,
  Spinner,
} from 'reactstrap';

import {
  Table, Thead, Tbody, Tr, Th, Td,
} from 'react-super-responsive-table';

import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

// import { Can } from '../../utilities/Can';
import classnames from 'classnames';
import BaseGrid from '../../components/Common/BaseGrid';
import * as url from '../../helpers/url_helper';
import { get, post, del } from '../../helpers/api_helper';
import { getBestBuyRgmReasonDetails } from '../../helpers/bestbuy_rgm_helper';
import SupplierModal from '../../components/Sourcing/SupplierModal';
import SupplierItemModal from '../../components/Sourcing/SupplierItemModal';

function Supplier(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  const { supplierId } = useParams();

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editSupplierItemModalOpen, setEditSupplierItemModalOpen] = useState(false);
  const [SupplierItemModalItem, setSupplierItemModalItem] = useState(null);
  const [entity, setEntity] = useState(null);
  const [revenueSummary, setRevenueSummary] = useState({
    last_30_days_revenue: 0,
    last_year_revenue: 0,
    all_time_revenue: 0,
  });
  const [revenueSummaryLoading, setRevenueSummaryLoading] = useState(true);
  const [happyReturnsSummary, setHappyReturnsSummary] = useState({
    shipped_qty: 0,
    returned_qty: 0,
    returned_value: 0,
    return_rate: 0,
    average_days_to_return: null,
    points: [],
    return_reasons: [],
  });
  const [happyReturnsLoading, setHappyReturnsLoading] = useState(true);
  const [bestBuyReturnsSummary, setBestBuyReturnsSummary] = useState({
    shipped_qty: 0,
    returned_qty: 0,
    returned_value: 0,
    return_rate: 0,
    average_days_to_return: null,
    points: [],
    return_reasons: [],
  });
  const [bestBuyReturnsLoading, setBestBuyReturnsLoading] = useState(true);
  const [orderLifecycleSummary, setOrderLifecycleSummary] = useState({
    average_cost_recovery_days: null,
    average_revenue_half_life_days: null,
    cost_recovery_sample_size: 0,
    revenue_half_life_sample_size: 0,
    order_count: 0,
  });
  const [orderLifecycleLoading, setOrderLifecycleLoading] = useState(true);
  const [signal, setSignal] = useState(0);
  const [activeTab, setActiveTab] = useState('1');

  const formatCurrency = (value) => new Intl.NumberFormat(
    'en-US',
    {
      style: 'currency',
      currency: 'USD',
    },
  ).format(Number(value) || 0);

  const formatDaysMetric = (value) => {
    if (!Number.isFinite(Number(value))) {
      return t('Not available yet');
    }

    return `${Number(value).toFixed(1)} ${t('days')}`;
  };

  const renderCardSpinner = () => (
    <div className="d-flex align-items-center justify-content-center py-4">
      <Spinner size="sm" color="primary" />
    </div>
  );

  const editSupplier = () => {
    setEditModalOpen(true);
  };

  const editSupplierItem = (x, e) => {
    setSupplierItemModalItem(x);
    setEditSupplierItemModalOpen(true);
  };

  const deleteSupplierItem = async (x, e) => {
    try {
      await del(`/api/sourcing/supplier/item/${x.id}`, { id: x.id });
      toastr.success(`Deleted supplier item ID: ${x.id}`, 'Success');
      setSignal(signal + 1);
    } catch (error) {
      toastr.error(error.message, 'Error');
    }
  };

  const newSupplierItem = () => {
    setSupplierItemModalItem({ suppliers_id: supplierId });
    setEditSupplierItemModalOpen(true);
  };

  const deleteSupplier = async (e) => {
    const btn = e.currentTarget;

    btn.disabled = true;
    btn.blur();
    btn.firstChild.classList.toggle('bx-spin');

    // eslint-disable-next-line no-alert
    const cnfrm = confirm(props.t(`Are you sure you want to delete this ${entity.name}?`));

    if (cnfrm) {
      try {
        await post(url.DELETE_SUPPLIER, { id: supplierId });

        toastr.success(`Deleted order ID: ${supplierId}`, 'Success');
        setSignal(signal + 1);
      } catch (error) {
        toastr.error(error.message, 'Error');
      } finally {
        btn.disabled = false;
        btn.firstChild.classList.toggle('bx-spin');
      }
    }
  };

  const watch = async (x) => {
    try {
      await post(`/api/sourcing/supplier/item/watch/${x.id}`);

      setSignal(signal + 1);
    } catch (error) {
      toastr.error(error.message, 'Error');
    }
  };

  const unwatch = async (x) => {
    try {
      await del(`/api/sourcing/supplier/item/watch/${x.id}`);

      setSignal(signal + 1);
    } catch (error) {
      toastr.error(error.message, 'Error');
    }
  };

  const onEditSuccess = () => {
    setSignal(signal + 1);
  };

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    const loadEntity = async () => {
      try {
        const supplierResponse = await get(`/api/sourcing/supplier/${supplierId}`);
        setEntity(supplierResponse);
      } catch (error) {
        toastr.error(error.message, 'Error');
      }
    };

    loadEntity();
  }, [supplierId, signal]);

  useEffect(() => {
    const loadRevenueSummary = async () => {
      setRevenueSummaryLoading(true);

      try {
        const revenueResponse = await get(`/api/sourcing/reports/supplier/${supplierId}/revenue-summary`);
        setRevenueSummary(revenueResponse || {
          last_30_days_revenue: 0,
          last_year_revenue: 0,
          all_time_revenue: 0,
        });
      } catch (error) {
        toastr.error(error.message, 'Error');
      } finally {
        setRevenueSummaryLoading(false);
      }
    };

    loadRevenueSummary();
  }, [supplierId, signal]);

  useEffect(() => {
    const loadHappyReturnsSummary = async () => {
      setHappyReturnsLoading(true);

      try {
        const happyReturnsResponse = await get(`/api/sourcing/reports/supplier/${supplierId}/happy-returns-summary`);
        setHappyReturnsSummary(happyReturnsResponse || {
          shipped_qty: 0,
          returned_qty: 0,
          returned_value: 0,
          return_rate: 0,
          average_days_to_return: null,
          points: [],
          return_reasons: [],
        });
      } catch (error) {
        toastr.error(error.message, 'Error');
      } finally {
        setHappyReturnsLoading(false);
      }
    };

    loadHappyReturnsSummary();
  }, [supplierId, signal]);

  useEffect(() => {
    const loadOrderLifecycleSummary = async () => {
      setOrderLifecycleLoading(true);

      try {
        const lifecycleResponse = await get(`/api/sourcing/reports/supplier/${supplierId}/order-lifecycle-summary`);
        setOrderLifecycleSummary(lifecycleResponse || {
          average_cost_recovery_days: null,
          average_revenue_half_life_days: null,
          cost_recovery_sample_size: 0,
          revenue_half_life_sample_size: 0,
          order_count: 0,
        });
      } catch (error) {
        toastr.error(error.message, 'Error');
      } finally {
        setOrderLifecycleLoading(false);
      }
    };

    loadOrderLifecycleSummary();
  }, [supplierId, signal]);

  useEffect(() => {
    const loadBestBuyReturnsSummary = async () => {
      setBestBuyReturnsLoading(true);

      try {
        const bestBuyResponse = await get(`/api/bestbuy/reports/supplier/${supplierId}/return-summary`);
        setBestBuyReturnsSummary(bestBuyResponse || {
          shipped_qty: 0,
          returned_qty: 0,
          returned_value: 0,
          return_rate: 0,
          average_days_to_return: null,
          points: [],
          return_reasons: [],
        });
      } catch (error) {
        toastr.error(error.message, 'Error');
      } finally {
        setBestBuyReturnsLoading(false);
      }
    };

    loadBestBuyReturnsSummary();
  }, [supplierId, signal]);

  const user = JSON.parse(localStorage.getItem('authUser'));
  const happyReturnsRatePercent = (Number(happyReturnsSummary?.return_rate) || 0) * 100;
  const happyReturnsReasonRows = Array.isArray(happyReturnsSummary?.return_reasons)
    ? happyReturnsSummary.return_reasons.slice(0, 5)
    : [];
  const happyReturnsRateSeries = Array.isArray(happyReturnsSummary?.points)
    ? happyReturnsSummary.points.map((point) => Number(point.return_rate || 0) * 100)
    : [];
  const happyReturnsRateCategories = Array.isArray(happyReturnsSummary?.points)
    ? happyReturnsSummary.points.map((point) => point.label || point.date)
    : [];
  const bestBuyReturnsRatePercent = (Number(bestBuyReturnsSummary?.return_rate) || 0) * 100;
  const bestBuyReasonRows = Array.isArray(bestBuyReturnsSummary?.return_reasons)
    ? bestBuyReturnsSummary.return_reasons.slice(0, 5)
    : [];
  const bestBuyReturnsRateSeries = Array.isArray(bestBuyReturnsSummary?.points)
    ? bestBuyReturnsSummary.points.map((point) => Number(point.return_rate || 0) * 100)
    : [];
  const bestBuyReturnsRateCategories = Array.isArray(bestBuyReturnsSummary?.points)
    ? bestBuyReturnsSummary.points.map((point) => point.label || point.date)
    : [];
  const happyReturnsChartOptions = {
    chart: {
      type: 'line',
      sparkline: {
        enabled: true,
      },
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    colors: ['#e2687e'],
    tooltip: {
      x: {
        show: true,
      },
      y: {
        formatter: (value) => `${Number(value || 0).toFixed(2)}%`,
      },
    },
    xaxis: {
      categories: happyReturnsRateCategories,
    },
    yaxis: {
      labels: {
        formatter: (value) => `${Number(value || 0).toFixed(1)}%`,
      },
    },
  };
  const bestBuyChartOptions = {
    chart: {
      type: 'line',
      sparkline: {
        enabled: true,
      },
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    colors: ['#58a6ff'],
    tooltip: {
      x: {
        show: true,
      },
      y: {
        formatter: (value) => `${Number(value || 0).toFixed(2)}%`,
      },
    },
    xaxis: {
      categories: bestBuyReturnsRateCategories,
    },
    yaxis: {
      labels: {
        formatter: (value) => `${Number(value || 0).toFixed(1)}%`,
      },
    },
  };

  return (
    <div className="page-content sourcing-supplier-page">
      <div className="container-fluid">
        <Row>
          <Col md="5">
            <Card className="sourcing-supplier-page__panel-card">
              <CardHeader className="bg-transparent border-bottom sourcing-supplier-page__panel-header">
                <div className="sourcing-supplier-page__eyebrow">
                  {t('Supplier Profile')}
                </div>
                <div className="sourcing-supplier-page__panel-title">
                  {entity !== null ? entity.name : '--'}
                </div>
              </CardHeader>
              <CardBody className="sourcing-supplier-page__panel-body">
                <div className="table-responsive sourcing-supplier-page__profile-table-wrap">
                  <Table size="sm" className="table table-bordered table-striped sourcing-supplier-page__profile-table">
                    <Tbody>
                      <Tr>
                        <Th>{t('Name')}</Th>
                        <Td>{entity === null ? '--' : entity.name}</Td>
                      </Tr>
                    </Tbody>
                  </Table>
                </div>

                <Button color="primary" className="btn-soft-primary sourcing-supplier-page__edit-button" onClick={editSupplier}>
                  <span className="mdi mdi-pencil" />
                </Button>
              </CardBody>
            </Card>

            <Card className="mt-3 sourcing-supplier-page__panel-card">
              <CardHeader className="bg-transparent border-bottom sourcing-supplier-page__panel-header">
                <div className="sourcing-supplier-page__panel-title">
                  {t('Orders')}
                </div>
              </CardHeader>
              <CardBody className="pt-0 sourcing-supplier-page__panel-body">
                {entity !== null && (
                  <BaseGrid
                    url="/api/sourcing/orders"
                    hasSearch
                    shouldUpdate={signal}
                    filters={`supplier_id=${entity.id}`}
                    config={
                    {
                      columns: {
                        id: {
                          label: 'ID',
                          sort: true,
                          link: {
                            to: '/sourcing/order/%id%',
                          },
                        },
                        reference: {
                          label: 'Reference',
                          sort: true,
                          link: {
                            to: '/sourcing/order/%id%',
                          },
                        },
                        supplier_program: { label: 'Program', sort: true },
                        created_at: {
                          label: 'Created At',
                          date: {
                            format: (date) => (moment(date).fromNow()),
                            timezone: process.env.LOCAL_TZ,
                          },
                          sort: true,
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 10,
                      },
                    }
                  }
                  />
                )}
              </CardBody>
            </Card>
          </Col>

          <Col md="7">
            <div className="sourcing-supplier-page__metrics-head mb-3">
              <div className="sourcing-supplier-page__eyebrow">
                {t('Performance')}
              </div>
              <div className="sourcing-supplier-page__metrics-title">
                {t('Revenue & Returns')}
              </div>
            </div>

            <Row className="g-3 mb-3">
              <Col md="4">
                <Card className="sourcing-supplier-page__stat-card h-100">
                  <CardBody>
                    <div className="sourcing-supplier-page__stat-label">
                      {t('30-Day Revenue')}
                    </div>
                    {revenueSummaryLoading ? renderCardSpinner() : (
                      <div className="sourcing-supplier-page__stat-value">
                        {formatCurrency(revenueSummary?.last_30_days_revenue)}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card className="sourcing-supplier-page__stat-card h-100">
                  <CardBody>
                    <div className="sourcing-supplier-page__stat-label">
                      {t('1 Year Revenue')}
                    </div>
                    {revenueSummaryLoading ? renderCardSpinner() : (
                      <div className="sourcing-supplier-page__stat-value">
                        {formatCurrency(revenueSummary?.last_year_revenue)}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card className="sourcing-supplier-page__stat-card h-100">
                  <CardBody>
                    <div className="sourcing-supplier-page__stat-label">
                      {t('All Time Revenue')}
                    </div>
                    {revenueSummaryLoading ? renderCardSpinner() : (
                      <div className="sourcing-supplier-page__stat-value">
                        {formatCurrency(revenueSummary?.all_time_revenue)}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row className="g-3 mb-3">
              <Col md="12">
                <Card className="sourcing-supplier-page__stat-card sourcing-supplier-page__return-card h-100">
                  <CardBody>
                    {happyReturnsLoading ? renderCardSpinner() : (
                      <div className="sourcing-supplier-page__return-layout">
                        <div className="sourcing-supplier-page__return-summary">
                          <div className="sourcing-supplier-page__stat-label">
                            {t('Happy Returns')}
                          </div>
                          <div className="sourcing-supplier-page__return-rate-row">
                            <div className="sourcing-supplier-page__stat-value sourcing-supplier-page__return-rate">
                              {happyReturnsRatePercent.toFixed(2)}
                              %
                            </div>
                            <div className="sourcing-supplier-page__return-pill">
                              {t('Return Rate')}
                            </div>
                          </div>
                          <div className="sourcing-supplier-page__return-grid">
                            <div className="sourcing-supplier-page__return-metric">
                              <div className="sourcing-supplier-page__return-metric-label">
                                {t('Returned Parts')}
                              </div>
                              <div className="sourcing-supplier-page__return-metric-value">
                                {Number(happyReturnsSummary?.returned_qty) || 0}
                                <span className="sourcing-supplier-page__return-metric-divider"> / </span>
                                {Number(happyReturnsSummary?.shipped_qty) || 0}
                              </div>
                            </div>
                            <div className="sourcing-supplier-page__return-metric">
                              <div className="sourcing-supplier-page__return-metric-label">
                                {t('Returned Value')}
                              </div>
                              <div className="sourcing-supplier-page__return-metric-value">
                                {formatCurrency(happyReturnsSummary?.returned_value)}
                              </div>
                            </div>
                          </div>
                          {happyReturnsReasonRows.length > 0 && (
                            <div className="sourcing-supplier-page__return-reasons">
                              <div className="sourcing-supplier-page__return-reasons-label">
                                {t('Top Return Reasons')}
                              </div>
                              <div className="sourcing-supplier-page__return-reasons-list">
                                {happyReturnsReasonRows.map((row) => (
                                  <div
                                    key={row.reason}
                                    className="sourcing-supplier-page__return-reason-row"
                                  >
                                    <span className="sourcing-supplier-page__return-reason-name">
                                      {row.reason}
                                    </span>
                                    <span className="sourcing-supplier-page__return-reason-stats">
                                      {`${(Number(row.percentage) * 100).toFixed(1)}%`}
                                      {' - '}
                                      {`${Number(row.count) || 0} ${t('returns')}`}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="sourcing-supplier-page__return-chart-wrap">
                          <div className="sourcing-supplier-page__return-chart-label">
                            {t('Quarterly Return Rate (Last 12 Months)')}
                          </div>
                          <div className="sourcing-supplier-page__return-chart-metrics">
                            <div className="sourcing-supplier-page__return-chart-metric">
                              <div className="sourcing-supplier-page__return-chart-metric-label">
                                {t('Avg Days To Return')}
                              </div>
                              <div className="sourcing-supplier-page__return-chart-metric-value">
                                {formatDaysMetric(happyReturnsSummary?.average_days_to_return)}
                              </div>
                            </div>
                          </div>
                          {happyReturnsRateSeries.length > 0 ? (
                            <Chart
                              options={happyReturnsChartOptions}
                              series={[{ name: t('Return Rate'), data: happyReturnsRateSeries }]}
                              type="line"
                              height={140}
                            />
                          ) : (
                            <div className="sourcing-supplier-page__return-empty">
                              {t('No Happy Returns history yet')}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row className="g-3 mb-3">
              <Col md="12">
                <Card className="sourcing-supplier-page__stat-card sourcing-supplier-page__return-card sourcing-supplier-page__return-card--bby h-100">
                  <CardBody>
                    {bestBuyReturnsLoading ? renderCardSpinner() : (
                      <div className="sourcing-supplier-page__return-layout">
                        <div className="sourcing-supplier-page__return-summary">
                          <div className="sourcing-supplier-page__stat-label">
                            {t('Best Buy Returns')}
                          </div>
                          <div className="sourcing-supplier-page__return-rate-row">
                            <div className="sourcing-supplier-page__stat-value sourcing-supplier-page__return-rate">
                              {bestBuyReturnsRatePercent.toFixed(2)}
                              %
                            </div>
                            <div className="sourcing-supplier-page__return-pill sourcing-supplier-page__return-pill--bby">
                              {t('Return Rate')}
                            </div>
                          </div>
                          <div className="sourcing-supplier-page__return-grid">
                            <div className="sourcing-supplier-page__return-metric">
                              <div className="sourcing-supplier-page__return-metric-label">
                                {t('Returned Parts')}
                              </div>
                              <div className="sourcing-supplier-page__return-metric-value">
                                {Number(bestBuyReturnsSummary?.returned_qty) || 0}
                                <span className="sourcing-supplier-page__return-metric-divider"> / </span>
                                {Number(bestBuyReturnsSummary?.shipped_qty) || 0}
                              </div>
                            </div>
                            <div className="sourcing-supplier-page__return-metric">
                              <div className="sourcing-supplier-page__return-metric-label">
                                {t('Returned Value')}
                              </div>
                              <div className="sourcing-supplier-page__return-metric-value">
                                {formatCurrency(bestBuyReturnsSummary?.returned_value)}
                              </div>
                            </div>
                          </div>
                          {bestBuyReasonRows.length > 0 && (
                            <div className="sourcing-supplier-page__return-reasons">
                              <div className="sourcing-supplier-page__return-reasons-label">
                                {t('Top Return Reasons')}
                              </div>
                              <div className="sourcing-supplier-page__return-reasons-list">
                                {bestBuyReasonRows.map((row) => {
                                  const reason = getBestBuyRgmReasonDetails(
                                    row.reason_code || row.reason,
                                    row.reason_family,
                                  );

                                  return (
                                    <div key={row.reason_key || `${row.reason_family}:${row.reason}`} className="sourcing-supplier-page__return-reason-row">
                                      <span className="sourcing-supplier-page__return-reason-name">
                                        <span className="d-block">
                                          {reason.title}
                                        </span>
                                        {reason.detail && (
                                          <span className="sourcing-supplier-page__return-reason-subtext">
                                            {reason.detail}
                                          </span>
                                        )}
                                      </span>
                                      <span className="sourcing-supplier-page__return-reason-stats">
                                        {`${(Number(row.percentage) * 100).toFixed(1)}%`}
                                        {' - '}
                                        {`${Number(row.count) || 0} ${t('returns')}`}
                                      </span>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="sourcing-supplier-page__return-chart-wrap">
                          <div className="sourcing-supplier-page__return-chart-label">
                            {t('Quarterly Return Rate (Last 12 Months)')}
                          </div>
                          <div className="sourcing-supplier-page__return-chart-metrics">
                            <div className="sourcing-supplier-page__return-chart-metric">
                              <div className="sourcing-supplier-page__return-chart-metric-label">
                                {t('Avg Days To Return')}
                              </div>
                              <div className="sourcing-supplier-page__return-chart-metric-value">
                                {formatDaysMetric(bestBuyReturnsSummary?.average_days_to_return)}
                              </div>
                            </div>
                          </div>
                          {bestBuyReturnsRateSeries.length > 0 ? (
                            <Chart
                              options={bestBuyChartOptions}
                              series={[{ name: t('Return Rate'), data: bestBuyReturnsRateSeries }]}
                              type="line"
                              height={140}
                            />
                          ) : (
                            <div className="sourcing-supplier-page__return-empty">
                              {t('No Best Buy return history yet')}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row className="g-3 mb-3">
              <Col md="6">
                <Card className="sourcing-supplier-page__stat-card h-100">
                  <CardBody>
                    <div className="sourcing-supplier-page__stat-label">
                      {t('Avg Cost Recovery Period')}
                    </div>
                    {orderLifecycleLoading ? renderCardSpinner() : (
                      <>
                        <div className="sourcing-supplier-page__stat-value sourcing-supplier-page__stat-value--compact">
                          {formatDaysMetric(orderLifecycleSummary?.average_cost_recovery_days)}
                        </div>
                        <div className="sourcing-supplier-page__metric-footnote">
                          {t('Based on')}
                          {' '}
                          {Number(orderLifecycleSummary?.cost_recovery_sample_size) || 0}
                          {' '}
                          {t('orders with cost recovery timestamps')}
                        </div>
                      </>
                    )}
                  </CardBody>
                </Card>
              </Col>
              <Col md="6">
                <Card className="sourcing-supplier-page__stat-card h-100">
                  <CardBody>
                    <div className="sourcing-supplier-page__stat-label">
                      {t('Avg Revenue Half-Life')}
                    </div>
                    {orderLifecycleLoading ? renderCardSpinner() : (
                      <>
                        <div className="sourcing-supplier-page__stat-value sourcing-supplier-page__stat-value--compact">
                          {formatDaysMetric(orderLifecycleSummary?.average_revenue_half_life_days)}
                        </div>
                        <div className="sourcing-supplier-page__metric-footnote">
                          {t('Based on')}
                          {' '}
                          {Number(orderLifecycleSummary?.revenue_half_life_sample_size) || 0}
                          {' '}
                          {t('orders with revenue half-life timestamps')}
                        </div>
                      </>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Nav tabs className="sourcing-supplier-page__tabs">
              <NavItem>
                <NavLink
                  style={{ cursor: 'pointer' }}
                  className={classnames('sourcing-supplier-page__tab', {
                    active: (activeTab === '1'),
                  })}
                  onClick={() => {
                    toggle('1');
                  }}
                >
                  {t('Watched Items')}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  style={{ cursor: 'pointer' }}
                  className={classnames('sourcing-supplier-page__tab', {
                    active: (activeTab === '2'),
                  })}
                  onClick={() => {
                    toggle('2');
                  }}
                >
                  {t('Full Catalog')}
                </NavLink>
              </NavItem>
            </Nav>

            <TabContent
              activeTab={activeTab}
            >
              <TabPane tabId="1">
                <Card className="sourcing-supplier-page__panel-card sourcing-supplier-page__tab-card">
                  <CardBody>
                    {entity !== null && (
                    <BaseGrid
                      url={`/api/sourcing/supplier/${entity.id}/items`}
                      hasSearch
                      shouldUpdate={signal}
                      className="table table-sm table-striped table-bordered"
                      filters={`watchers.user_id=${user.id}`}
                      config={
                      {
                        columns: {
                          supplier_sku: {
                            label: 'Vendor SKU',
                            sort: true,
                          },
                          linked_item: {
                            label: 'Item',
                            sort: true,
                            format: (y, x) => (y !== null ? `${y.part_number}` : ''),
                            link: {
                              to: '/item/%items_id%',
                            },
                          },
                          stock_id: {
                            label: 'Stock ID',
                            sort: true,
                          },
                          price: {
                            label: 'Price',
                            sort: true,
                            format: formatCurrency,
                          },
                          notes: {
                            label: 'Notes',
                            sort: true,
                          },
                          actions: {
                            label: props.t('Actions'),
                            actions: [
                              {
                                key: 'watch',
                                icon: 'mdi mdi-checkbox-blank-outline',
                                class: 'btn btn-sm btn-dark btn-soft-dark pe-1 ps-1 pb-0 pt-0 fs-4',
                                alt: props.t('Click to Start Watching'),
                                condition: (x) => (
                                  x.watchers.filter((y) => y.user_id === user.id).length === 0
                                ),
                                click: watch,
                              },
                              {
                                key: 'unwatch',
                                icon: 'mdi mdi-check-box-outline',
                                class: 'btn btn-sm btn-success btn-soft-success pe-1 ps-1 pb-0 pt-0 fs-4',
                                alt: props.t('Click to Stop Watching'),
                                condition: (x) => (
                                  x.watchers.filter((y) => y.user_id === user.id).length > 0
                                ),
                                click: unwatch,
                              },
                              {
                                key: 'edit',
                                icon: 'bx bx-pencil',
                                class: 'btn btn-sm btn-primary btn-soft-primary',
                                alt: props.t('Edit'),
                                click: editSupplierItem,
                              },
                              {
                                key: 'delete',
                                icon: 'mdi mdi-delete',
                                class: 'btn btn-sm btn-soft-danger',
                                alt: props.t('Delete'),
                                click: deleteSupplierItem,
                              },
                            ],
                          },
                        },
                        pagination: {
                          sort: 'id',
                          direction: 'desc',
                          perPage: 10,
                        },
                      }
                    }
                    />
                    )}
                  </CardBody>
                </Card>
              </TabPane>
              <TabPane tabId="2">
                <Card className="sourcing-supplier-page__panel-card sourcing-supplier-page__tab-card">
                  <CardBody>
                    {entity !== null && (
                    <BaseGrid
                      url={`/api/sourcing/supplier/${entity.id}/items`}
                      hasSearch
                      shouldUpdate={signal}
                      className="table table-sm table-striped table-bordered"
                      create={newSupplierItem}
                      config={
                      {
                        columns: {
                          supplier_sku: {
                            label: 'Supplier SKU',
                            sort: true,
                          },
                          linked_item: {
                            label: 'Linked Item',
                            sort: true,
                            format: (y, x) => (y !== null ? `${y.part_number}` : ''),
                            link: {
                              to: '/item/%items_id%',
                            },
                          },
                          stock_id: {
                            label: 'Stock ID',
                            sort: true,
                          },
                          price: {
                            label: 'Price',
                            sort: true,
                            format: formatCurrency,
                          },
                          notes: {
                            label: 'Notes',
                            sort: true,
                          },
                          actions: {
                            label: props.t('Actions'),
                            actions: [
                              {
                                key: 'watch',
                                icon: 'mdi mdi-checkbox-blank-outline',
                                class: 'btn btn-sm btn-dark btn-soft-dark pe-1 ps-1 pb-0 pt-0 fs-4',
                                alt: props.t('Click to Start Watching'),
                                condition: (x) => (
                                  x.watchers.filter((y) => y.user_id === user.id).length === 0
                                ),
                                click: watch,
                              },
                              {
                                key: 'unwatch',
                                icon: 'mdi mdi-check-box-outline',
                                class: 'btn btn-sm btn-success btn-soft-success pe-1 ps-1 pb-0 pt-0 fs-4',
                                alt: props.t('Click to Stop Watching'),
                                condition: (x) => (
                                  x.watchers.filter((y) => y.user_id === user.id).length > 0
                                ),
                                click: unwatch,
                              },
                              {
                                key: 'edit',
                                icon: 'bx bx-pencil',
                                class: 'btn btn-sm btn-primary btn-soft-primary',
                                alt: props.t('Edit'),
                                click: editSupplierItem,
                              },
                              {
                                key: 'delete',
                                icon: 'mdi mdi-delete',
                                class: 'btn btn-sm btn-soft-danger',
                                alt: props.t('Delete'),
                                click: deleteSupplierItem,
                              },
                            ],
                          },
                        },
                        pagination: {
                          sort: 'id',
                          direction: 'desc',
                          perPage: 10,
                        },
                      }
                    }
                    />
                    )}
                  </CardBody>
                </Card>
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </div>

      {entity !== null && (
        <SupplierModal shown={editModalOpen} entity={entity} onSuccess={onEditSuccess} />
      )}

      {SupplierItemModalItem !== null && (
        <SupplierItemModal
          shown={editSupplierItemModalOpen}
          item={SupplierItemModalItem}
          onSuccess={() => { setEditSupplierItemModalOpen(false); setSignal(signal + 1); }}
          onClose={() => { setEditSupplierItemModalOpen(false); }}
        />
      )}
    </div>
  );
}

Supplier.defaultProps = {
  t: (x) => (x),
};

Supplier.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Supplier));
